import { readableColor as rc } from "polished";

const memoize = new Map([["#000", "#fff"]]);

export function readableColor(color) {
  if (memoize.has(color)) {
    return memoize.get(color);
  }

  const readColor = rc(color);

  memoize.set(color, readColor);

  return readColor;
}
